// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useModuleParty } from '../../contexts/ModuleContext';
import { baseRoutes, operatorRoutes, userRoutes } from '../../modules/Collateral/routes';
import { useCollateralUserService } from '../queries/collateral/onboarding/useUserService';
import { useOperatorParty } from '../queries/utility-operator/useOperatorParty';

export const useCollateralEntries = () => {
  const userService = useCollateralUserService();
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  const isOperator = party === operator;
  const isUser = !!userService.data;
  let entries = baseRoutes;

  if (isOperator) {
    entries = entries.concat(operatorRoutes);
  }

  if (isUser) {
    entries = entries.concat(userRoutes);
  }
  return entries;
};
